import jQuery from 'jquery';
import React from 'react';
import CheckboxList from './ui/CheckboxList.jsx';
import Dropdown from './ui/Dropdown.jsx';
import Image from './ui/Image.jsx';
import Button from './ui/button/Button.jsx';
import Configurator from './Configurator.jsx';
import styles from './ElectTechClosetAccessoryConfigurator.styl';

/**
 * Конфигуратор аксессуаров к металлическим оболочкам IEK
 */
class ElectTechClosetAccessoryConfigurator extends Configurator
{
	constructor(props) {
		super(props);

		this.state = {
			specList: {},
			enclosureArticleSearch: false
		};

		this.onListItemCheck          = this.onListItemCheck.bind(this);
		this.onBtnSpecSaveClick       = this.onBtnSpecSaveClick.bind(this);
		this.onSwitchConfigurator     = this.onSwitchConfigurator.bind(this);
		this.onBtnExcelClick          = this.onBtnExcelClick.bind(this);
		this.onSpecListChange         = this.onSpecListChange.bind(this);
		this.onEnclosureArticleSearch = this.onEnclosureArticleSearch.bind(this);
		this.onEnclosureArticleSearchBlur = this.onEnclosureArticleSearchBlur.bind(this);
		this.onDownloadInstruction = this.onDownloadInstruction.bind(this);
	}

	getType() {
		return 'electTechCloset_accessory';
	}

	getCustomStyles() {
		return styles;
	}

	applyFilters() {
		let accessories = super.applyFilters('accessory');

		accessories = accessories.filter(accessory => {
			const enc2acc = this.db.list.enclosure2accessory[this.enclosure.article];
			return (Array.isArray(enc2acc) && enc2acc.indexOf(accessory.article) >= 0);
		});

		return accessories;
	}

	cleanFilter(article) {
		let types = [];
		let accessories = this.db.list.accessory;

		accessories = accessories.filter(accessory => {
			if(article in this.db.list.enclosure2accessory) {
				return (this.db.list.enclosure2accessory[article].indexOf(accessory.article) >= 0);
			} else {
				return false;
			}
		});

		for(let i = 0; i < accessories.length; i++)
		{
			if(accessories[i].type_id && types.indexOf(accessories[i].type_id) !== 0)
			{
				types.unshift(accessories[i].type_id);
			}
		}

		this.db.filter.type = this.filters;

		let filt = [];

		this.db.filter.type.every(typeId_value => {
			const [id, ] = typeId_value.split('_');
			for (let i = 0; i < types.length; i++)
			{
				if (id === types[i] && filt.indexOf(typeId_value) === -1) {
					filt.unshift(typeId_value);
				}
			}
			return true;
		});

		filt.sort();
		filt.unshift('0_Все');

		this.db.filter.type = filt;
		this.filter['type'] = filt[0];
	}

	loadDb() {
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'get'
			},
			db => {
				this.db = db;
				this.db.filter.type.unshift('0_Все');


				if (this.props.enclosure) {
					this.enclosure = this.getEnclosureByArticle(this.props.enclosure);
					this.filters = this.db.filter.type;
				} else {
					this.enclosure = this.db.list.enclosure[0];
					this.filters = this.db.filter.type;
				}

				const items = this.applyFilters();

				this.cleanFilter(this.enclosure.article);

				const articles = items.map(item => {
					return item.article;
				});
				const abbreviation = items.map(item => {
					return {article:item.article, abbreviation:item.abbreviation};
				});

				this.setState({
					articles, abbreviation
				});
			}
		);
	}

	doPrint(params) {
		let _params = params || {};

		_params.data = {
			enclosure: `[${this.enclosure.article}] ${this.enclosure.name}`,
			speclist: JSON.stringify(this.state.specList)
		};

		super.doPrint(_params);
	}

	getEnclosureByArticle(article) {
		for (let i = 0; i < this.db.list.enclosure.length; i++)
		{
			if (this.db.list.enclosure[i].article === article) {
				return this.db.list.enclosure[i];
			}
		}

		return null;
	}

	onEnclosureChange(article) {
		this.enclosure = this.getEnclosureByArticle(article);
		this.setState({
			enclosureArticleSearch: false,
			specList: {}
		});
		let accessories = this.db.list.accessory;
		let items = accessories.filter(accessory => {
			if(article in this.db.list.enclosure2accessory) {
				return (this.db.list.enclosure2accessory[article].indexOf(accessory.article) > 0);
			} else {
				this.filter = {};
			}
		});
		if(items.length > 0)
		{
			const articles = items.map(item => {
					return item.article;
			});

			const abbreviation = items.map(item => {
				return {article:item.article, abbreviation:item.abbreviation};
			});
			this.setState({
					articles: articles, abbreviation
			});
			delete this.filter;
			this.filter = {};
			this.cleanFilter(article);
			this.filter['type'] = this.db.filter.type[0];
			this.onFilterChange('type', 'Все');
		}
		else
		{
			this.setState({
				item: null,
				articles: []
			});
			delete this.filter;
			this.filter = {};
			this.cleanFilter(article);
			this.filter['type'] = this.db.filter.type[0];
			this.onFilterChange('type', 'Все');
		}
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}

	onBtnSpecSaveClick() {
		this.setState(prevState => {
			let specList = prevState.specList;

			if (specList[this.state.item.article])
			{
				specList[this.state.item.article].count++;
			}
			else
			{
				specList[this.state.item.article] = {
					count: 1,
					name: this.state.item.name,
					article: this.state.item.article
				};
			}

			return specList;
		},()=>{
			this.preDoAddToCart()
		});
	}
	preDoAddToCart(){
		let specList=[]
		specList.push(this.enclosure)
		for(let i in this.state.specList){
			specList.push(this.state.specList[i])
		}
		this.doAddToCart(specList)
	}

	onDownloadInstruction(item) {
		if (!item || !item.instruction) {
			return;
		}
		window.location = `itkcfg.php?action=getFileZip&type=${this.getType()}&name=instruction&article=${item.instruction}`;
	}

	onFilterChange(prop, value) {
		if (prop === 'type')
		{
			if (value !== 'Все')
			{
				this.filter = {};

				this.db.filter.type.every(typeId_value => {
					const [, typeName] = typeId_value.split('_');

					if (typeName === value) {
							value = typeId_value;
							return false;
					}
					return true;
				});
				this.setState({type_value: true});
			}
			else
			{
				let accessories = this.db.list.accessory;
				accessories = accessories.filter(accessory => {
					return (this.db.list.enclosure2accessory[this.enclosure.article].indexOf(accessory.article) >= 0);
				});

				const items = accessories;

				const articles = items.map(item => {
						return item.article;
				});
				const abbreviation = items.map(item => {
					return {article:item.article, abbreviation:item.abbreviation};
				});
				this.setState({
					 articles: articles, abbreviation
				});
				this.cleanFilter(this.enclosure.article);

				this.onListItemCheck(articles[0]);
			}
		}

		super.onFilterChange(prop, value);

		if ((value === 'Все') && (prop === 'type'))
		{
			this.filter = {type: '0_Все'};
			this.setState({type_value: false});
		}
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator();
		}
	}

	onSpecListChange(article, count) {
		this.setState(prevState => {
			const specList = prevState.specList;
			const countInt = parseInt(count);

			if (countInt <= 0) {
				delete specList[article];
			} else {
				specList[article].count = isNaN(countInt) ? 1 : countInt;
			}

			return specList;
		},()=>{
			this.preDoAddToCart()
		});
	}

	onEnclosureArticleSearch(event) {
		const article = event.target.value.toUpperCase();

		if (!article)
		{
			this.setState({
				enclosureArticleSearch: article
			});

			return;
		}
		this.cleanFilter(article);

		const enclosure = this.getEnclosureByArticle(article);

		if (enclosure)
		{
			this.onEnclosureChange(article);
		}
		else
		{
			this.setState({
				enclosureArticleSearch: article
			});
		}
		super.updateList();
		const articles = items.map(item => {
			return item.article;
		});

		const abbreviation = items.map(item => {
			return {article:item.article, abbreviation:item.abbreviation};
		});

		this.setState({
			articles, abbreviation
		});

		this.cleanFilter(article);
	}

	onEnclosureArticleSearchChange() {
		this.cleanFilter(this.enclosure.article);
		super.updateList();
	}

	onEnclosureArticleSearchBlur() {
		if (this.state.enclosureArticleSearch !== false) {
			this.setState({
				enclosureArticleSearch: false
			});
		}
		this.cleanFilter(this.enclosure.article);
		super.updateList();
	}

	buildDropdownFilters() {
		const stateFilters = this.db.filter;

		let dynamicFilters = [];

		let dropDownTop = 290;
		let dropDownLeft = 35;
		let dropDownItem = 1;

		Object.keys(this.db.filter).forEach(filterPropName => {
			if (filterPropName === 'type') {
				return;
			}

			const [typeId, itemPropName] = filterPropName.split('_');

			const [filterTypeId] = this.filter.type.split('_');

			if (typeId !== filterTypeId) {
				return;
			}

			let filterItems = ['Все'];

			stateFilters[filterPropName].forEach((filterItemValue) => {

				const prevFilterValue = this.filter[itemPropName];

				if (prevFilterValue) {
					// Какие варианты, если бы фильтр не был применен
					delete this.filter[itemPropName];
				}

				const itemList = this.applyFilters();

				const articles = itemList.map(item => {
					return item.article;
				});

				for (let itemIndex in itemList) {
					const item = itemList[itemIndex];

					if (articles.indexOf(item.article) < 0) {
						continue;
					}

					if (item[itemPropName] === filterItemValue) {
						filterItems.push(filterItemValue);
						break;
					}
				}

			});

			dynamicFilters.push(
				<Dropdown
					key={filterPropName}
					items={filterItems}
					onItemChange={value => this.onFilterChange(itemPropName, value)}
					className={styles.accessoryTypeList}
					style={{top: dropDownTop + 'px', left: dropDownLeft + 'px'}}
					selectStyle={{width: '140px'}}
					label={`${itemPropName}:`}
				/>
			);
			if(dropDownItem == 3){
				dropDownTop = 290;
				dropDownLeft = 182;
			}else{
				dropDownTop += 42;
			}
			dropDownItem += 1;
		});

		return dynamicFilters;
	}

	getCustomElements() {
			let elements = [];

		if(this.enclosure.instruction) {
			elements.push(
				<Button
					x="683"
					y="627"
					buttonStyle={styles.mainBtnInstruction}
					textStyle={styles.mainBtnTextInstruction}
					iconStyle={styles.pdfBtnIconInstruction}
					text="Инструкция по монтажу"
					onClick={() => this.onDownloadInstruction(this.enclosure)}
					key="instructionPdf"
				/>
			);
		}
			elements.push(
					<Button
						x="34"
						y="192"
						buttonStyle={styles.mainBtnGrey}
						textStyle={styles.mainBtnTextSpec}
						iconStyle={styles.btnSwitchToEnclosureConfIcon}
						text="Перейти к подбору шкафов по параметрам"
						onClick={this.onSwitchConfigurator}
						key="swconf"
					/>
				);
			elements.push(
				<Button
					x="24"
					y="675"
					buttonStyle={styles.mainBtnGreyShort}
					buttonDisabledStyle={styles.mainBtnDisabled}
					textStyle={styles.mainBtnTextCenteredShort}
					iconStyle={styles.calcBtnIcon}
					text="Сохранить в спецификацию"
					disabled={!this.state.item}
					onClick={this.onBtnSpecSaveClick}
					key="specsave"
					/>
				);

		elements.push(
			<Button
				x="177"
				y="675"
				buttonStyle={styles.mainBtnGreyShort}
				buttonDisabledStyle={styles.mainBtnDisabledShort}
				textStyle={styles.mainBtnTextCenteredShort}
				iconStyle={styles.calcBtnIcon}
				text="В корзину"
				disabled={!this.state.item}
				onClick={this.onBtnCartClick}
				key="addtocart"
			/>
		);
			elements.push(
					<Button
						x="358"
						y="675"
						buttonStyle={styles.mainBtn}
						textStyle={styles.mainBtnText}
						iconStyle={styles.pdfBtnIcon}
						text="Сохранить в PDF"
						onClick={this.onBtnPrintPdfClick}
						key="printpdf"
					/>
				);
			elements.push(
					<Button
						x="586"
						y="675"
						buttonStyle={styles.mainBtn}
						textStyle={styles.mainBtnText}
						iconStyle={styles.printBtnIcon}
						text="Распечатать"
						onClick={this.onBtnPrintClick}
						key="print"
					/>
					);

			elements.push(
					<Button
						x="810"
						y="675"
						buttonStyle={styles.mainBtn}
						textStyle={styles.mainBtnText}
						iconStyle={styles.excelBtnIcon}
						text="Сохранить в Excel"
						onClick={this.onBtnExcelClick}
						key="excel"
					/>
			);

			return elements;
		}

	render() {
		if (!this.db) {
			return <div className={styles.cfg}></div>;
		}

		let filtt = [];
		let typeFilterItems = this.db.filter.type.map(type => {
			const [, typeName] = type.split('_');
			if(typeName !== 'Все'){
				filtt.unshift(typeName);
			}
			return typeName;
		});
		typeFilterItems.sort();
		typeFilterItems.unshift('Все');
		filtt.sort();
		filtt.unshift('Все');
		typeFilterItems = filtt;

		return (
			<div className={styles.cfg}>

				{/* Заголовок конфигуратора */}
				<span className={styles.title}>Конфигуратор аксессуаров к металлическим оболочкам IEK</span>

				{/* Поиск шкафа по артикулу */}
				<input
					className={styles.electTechClosetArticle}
					type="text"
					value={this.state.enclosureArticleSearch !== false ? this.state.enclosureArticleSearch : this.enclosure.article}
					onInput={this.onEnclosureArticleSearch}
					onChange={this.onEnclosureArticleSearchChange}
					onBlur={this.onEnclosureArticleSearchBlur}
					style={{backgroundColor: this.state.enclosureArticleSearch === false ? null : '#f88'}}
				/>

				{/* Выбрать шкаф из списка */}
				<select className={styles.electTechClosetList} value={this.enclosure.article} onChange={e => this.onEnclosureChange(e.target.value)} title={this.enclosure.name}>
					{this.db.list.enclosure.map(enclosure => {
						return <option value={enclosure.article} key={enclosure.article}>{enclosure.name}</option>;
					})}
				</select>

				{/* Тип аксессуара */}
				<Dropdown
					label="Тип аксессуара:"
					className={styles.accessoryTypeList}
					items={typeFilterItems}
					value={(this.state.type_value === false) ? typeFilterItems[0] : this.filter.type.split('_')[1]}
					onItemChange={value => this.onFilterChange('type', value)}
					style={{top: '243px'}}
					selectStyle={{width: '287px'}}
				/>

				{/* Динамические фильтры */}
				{this.buildDropdownFilters()}

				<span className={styles.abbreviation}>Наименование</span>

				{/* Список артикулов аксессуаров */}
				<CheckboxList
					className={styles.accessoryList}
					items={this.state.articles}
					abbreviation={this.state.abbreviation}
					onItemCheck={this.onListItemCheck}
					selectedValue={this.state.item ? this.state.item.article : null}
				/>

				{/* Список спецификации */}
				<SpecList
					ref="specList"
					items={this.state.specList}
					onChange={this.onSpecListChange}
					enclosure={this.enclosure.article}
				/>

				{/* Артикул и название */}
				{this.state.item ? (
					<a href={`https://www.iek.ru/products/catalog/?page=detail&article=${this.state.item.article}`} target="_blank">
						<div className={styles.name}>
							<div><strong>{this.state.item.article}</strong></div>
							<div>{this.state.item.name}</div>
						</div>
					</a>
				) : (
					<div className={styles.nameEmpty}></div>
				)}

				{/* Описание */}
				{this.state.item && this.state.item.description ? (
					<div className={styles.description}>{this.state.item.description}</div>
				) : (
					<div className={styles.descriptionEmpty}></div>
				)}

				{/* Изображение */}
				<Image
					className={styles.preview}
					url={this.state.item && this.state.item.photo ? `itkcfg.php?type=${this.getType()}&action=getPhoto&article=${this.state.item.article}` : null}
					noPhoto={this.state.item && !this.state.item.photo}
				/>

				{this.getCustomElements ? this.getCustomElements() : null}

				{/* На основной сайт IEK */}

				<div style={{position: 'absolute', backgroundColor: '#ffffff', width: '50%', height: '22px', top: '723px'}}/>
				<a className={styles.homeLink} href={'https://www.iek.ru/'} target="_blank">На основной сайт IEK</a>

				{/* Техническая поддержка */}
				<div style={{
					position: 'absolute',
					backgroundColor: '#ffc93a',
					width: '50%',
					height: '22px',
					top: '723px',
					left: '513px'
				}}/>
				<a style={{
					position: 'absolute',
					top: '726px',
					left: '250px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.iek.ru/support/techsupport/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-27</span>
			</div>
		);
	}
}

/**
 * Список спецификации (наименование - кол-во)
 */
class SpecList extends React.Component
{
	render() {
		const rows = Object.keys(this.props.items).map((article, itemIndex) => {

			const itemCount = this.props.items[article].count;

			const rowClassName = (itemIndex % 2 === 0 ? `${styles.specListTableRow} ${styles.specListTableRow_even}` : styles.specListTableRow);

			return (
				<tr key={article} className={rowClassName}>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellArticle}`}>{article}</td>
					<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellCount}`}>
						<input type="text" value={itemCount} className={styles.specListCountInput}
									 onChange={e => this.props.onChange(article, e.target.value)} />
						<span className={styles.specListDelete} title="Удалить позицию"
									onClick={() => this.props.onChange(article, 0)} />
					</td>
				</tr>
			);

		});

		return (
			<div className={styles.specList}>
				<table className={styles.specListTable}>
					<colgroup>
						<col style={{width: '226px'}}/>
						<col style={{width: '124px'}}/>
					</colgroup>
					<tbody>

						<tr className={styles.specListTableRow}>
							<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellArticle}`}>{this.props.enclosure}</td>
							<td className={`${styles.specListTableRowCell} ${styles.specListTableRowCellCount}`}>1</td>
						</tr>

						{rows}

					</tbody>
				</table>
			</div>
		);
	}
}

export default ElectTechClosetAccessoryConfigurator;



// WEBPACK FOOTER //
// ./src/react/ElectTechClosetAccessoryConfigurator.jsx